import React, { useContext, FC } from 'react';
import { Icon } from 'view/atoms';
import { close, menu } from 'static/icons/resizable';
import { SideBarContentType } from 'interfaces';
import { HeaderContext } from '../HeaderContext';
import * as S from './BurgerMenu.styles';

export const BurgerMenu: FC = () => {
  const {
    isSideBarOpen,
    sideBarContentType,
    toggleSideBar,
    setSideBarType,
    toggleSearchList,
  } = useContext(HeaderContext);

  const onClick = () => {
    switch (sideBarContentType) {
      case SideBarContentType.menu: {
        toggleSideBar();
        break;
      }

      case SideBarContentType.search: {
        toggleSideBar();
        toggleSearchList();
        setSideBarType(SideBarContentType.menu);
        break;
      }

      default: {
        break;
      }
    }
  };

  return (
    <S.BurgerMenuStyled onClick={onClick} className='safe-to-click'>
      <Icon src={isSideBarOpen ? close : menu} />
    </S.BurgerMenuStyled>
  );
};
